import { withTranslation } from "i18n";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { Alert, Button, Spinner } from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { getAssignmentStartAsync, resetPlanOffset } from "redux/assignment/assignment.actions";
import { selectAssignmentData, selectAssignmentLoadMore, selectAssignmentOffset, selectErrorFetchingAssignments, selectIsFetchingAssignments } from "redux/assignment/assignment.selectors";
import { commonStrigns, stringFiles } from "res/strings";
import { createStructuredSelector } from "reselect";
import { Box } from "styled-components/box";
import { SkeletonLine } from "styled-components/skeleton/SkeletonLine";
import { CookieUtils } from "utils";
import PlanCard from "../../components/assignment/PlanCard";


const Plan = ({t}) => {
  const [show, setShow] = useState(true);

  const dispatch = useDispatch();
  const router = useRouter();
  const cookieInstance = new CookieUtils();
  const studentID= cookieInstance.getCookie("studentID");
  const semesterID=cookieInstance.getCookie("semesterID");

  const {
    assignmentData,
    isFetchingAssignments,
    errorFetchingAssignments,
    offset,
    loadMore,
    currentUser,
  } = useSelector(
    createStructuredSelector({
      assignmentData: selectAssignmentData,
      isFetchingAssignments: selectIsFetchingAssignments,
      errorFetchingAssignments: selectErrorFetchingAssignments,
      offset: selectAssignmentOffset,
      loadMore: selectAssignmentLoadMore,
    })
  );

  useEffect(() => {
    dispatch(resetPlanOffset());
    getAssignmentList()
  }, []);


  const getAssignmentList = () => {
    dispatch(getAssignmentStartAsync({ studentID: studentID ,semesterID: semesterID }))
  }


  return (
    <Box  className="w-100 d-flex flex-column p-2">
      {isFetchingAssignments && !loadMore ? (
        //Loading
           <>
          {[1, 2, 3,4,5,6].map((item, idx) => (
                 <Box key={idx} width="100%" height="50px" className="my-1">
                  <SkeletonLine />
                </Box>
            ))}
           </>
      ) : assignmentData && !errorFetchingAssignments ? (
         //Show Data
         <>
          <Button className="m-2 w-50" onClick={() => {
             dispatch(resetPlanOffset());
             getAssignmentList()
          }}
           variant="outline-info">
             دریافت تکالیف جدید
          </Button>
         <InfiniteScroll
          dataLength={assignmentData.length} //This is important field to render the next data
          next={() => getAssignmentList()}
          hasMore={loadMore}
          loader={<Spinner className='d-flex mx-auto align-self-center' animation="border" />}
          // endMessage={
          //   <p className='text-success' style={{ textAlign: 'center' }}>
          //     {t(AssignmentString.listFinish)}
          //   </p>
          // }
           // below props only if you need pull down functionality
          refreshFunction={()=>{
            dispatch(resetPlanOffset())
            getAssignmentList();
          }}
          pullDownToRefresh
          pullDownToRefreshThreshold={100}
          pullDownToRefreshContent={
            <p style={{ textAlign: 'center' }}>دریافت مجدد لیست</p>
          }
          releaseToRefreshContent={
            <p style={{ textAlign: 'center' }}>دریافت مجدد لیست</p>
          }
        >
          {assignmentData.map((assignment, id) => (
            <PlanCard {...assignment} duration={false} key={id}/>
          ))}

        </InfiniteScroll>
        {assignmentData.length===0 &&
         <h3 className="text-center mt-5 app-text-gray">تکلیف جاری برای شما وجود ندارد</h3>
          }
        </>
        
      ) : (
        //Error
        <Alert  show={show} variant="danger">
          <Alert.Heading>{t(commonStrigns.error)}</Alert.Heading>
          <p>
          {errorFetchingAssignments}
          </p>
          <hr />
          <div >
            <Button onClick={() => getAssignmentList()} variant="outline-danger">
            {t(commonStrigns.retry)}
            </Button>
          </div>
        </Alert>
       )
           }
    </Box>
  );
};

export default withTranslation(stringFiles.common)(Plan);
